import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { VehicleHistoryQuery } from '@/core/domain/workorder/VehiclesHistory/VehiclesHistory.types';
import { removePlateMask } from '@/utils/mask/removeMask';

function VehiclesHistoryExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<VehicleHistoryQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={6}>
        <Input
          value={queryParams?.custumerFilter}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, custumerFilter: value }))
          }
          placeholder={intl.formatMessage({
            id: 'vehiclesHistory.list.header.customer',
          })}
        />
      </Col>

      <Col xs={24} sm={24} md={6}>
        <Input
          value={queryParams?.licensePlateFilter}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({
              ...prev,
              licensePlateFilter: removePlateMask(value),
            }))
          }
          placeholder={intl.formatMessage({
            id: 'vehiclesHistory.list.column.licensePlate',
          })}
        />
      </Col>

      <Col xs={24} sm={24} md={6}>
        <Input
          value={queryParams?.vehicleFilter}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, vehicleFilter: value }))
          }
          placeholder={intl.formatMessage({
            id: 'vehiclesHistory.list.column.vehicle',
          })}
        />
      </Col>

      <Col xs={24} sm={24} md={6}>
        <Input
          value={queryParams?.fleet}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, fleet: value }))
          }
          placeholder={intl.formatMessage({
            id: 'vehiclesHistory.list.column.fleet',
          })}
        />
      </Col>
    </Row>
  );
}

export default VehiclesHistoryExtraFilters;
